import React from 'react';
import { HSLColor, RGBColor } from 'react-color';
import { Saturation, Hue } from 'react-color/lib/components/common';
import { ColorWrapChangeHandler } from 'react-color/lib/components/common/ColorWrap';
import { getBGColor, getFontColor } from '../../components/color-parser';

import styles from './StyledColorPicker.module.scss';
import { useUniSelector } from '@lmt/unicorn-shared/app/store/types';
import { getSettings } from '@lmt/unicorn-shared/app/features/settings/selectors';

export interface StyledColorPickerProps {
  hex?: string;
  hsl?: HSLColor;
  rgb?: RGBColor;
  onChange: ColorWrapChangeHandler;
}
export const StyledColorPicker: React.FC<StyledColorPickerProps> = (props) => {
  const isNightTheme = useUniSelector(getSettings).isNightTheme;
  const color = getBGColor(props.hex ?? 'transparent', isNightTheme);
  return (
    <div className={styles.container}>
      <div
        className={styles.currentColorContainer}
        style={{ backgroundColor: getBGColor(color) }}
      >
        <div
          className={styles.currentColorText}
          style={{ color: getFontColor(color) }}
        >
          {props.hex}
        </div>
      </div>
      <div className={styles.saturation}>
        <Saturation {...props} className={styles.saturation} />
      </div>
      <div className={styles.hue}>
        <Hue {...props} className={styles.hue} direction={'horizontal'} />
      </div>
    </div>
  );
};
